import { z } from "zod"
import { ParsedAPIRes } from "@/types/types"

const ForgotPasswordSchema = z.object({
  email: z.string().email("Must be a valid email address"),
  recaptchaResponse: z.string(),
})

type Input = z.infer<typeof ForgotPasswordSchema>

export type ForgotPasswordKeys = keyof Input

type ErrorCode = "INVALID_RECAPTCHA" | "FALLBACK_ERROR"

type Output = string

export type ForgotPassword = (input: Input) => ParsedAPIRes<Output, ErrorCode>

export function validateForgotPassword(input: Input) {
  const { data, error } = ForgotPasswordSchema.safeParse(input)

  if (error) {
    return [null, error.flatten().fieldErrors] as const
  }
  return [data, null] as const
}
